export const MIN_INSTALLMENTS: number = 1;

export const MAX_INSTALLMENTS: number = 10;

export const INSTALLMENT_OPTIONS: readonly number[] = Array.from(
  { length: MAX_INSTALLMENTS },
  (_, index: number): number => index + MIN_INSTALLMENTS,
);
